import { show404 } from '#scripts/_404.js';

export default function () {
  return show404();
}
